import { useTranslation } from "react-i18next";
import emixaLogo from "@/assets/logos/emixa.png";
import fellowmindLogo from "@/assets/logos/fellowmind.png";
import conclusionLogo from "@/assets/logos/conclusion.png";
import berenschotLogo from "@/assets/logos/berenschot.png";
import siersLogo from "@/assets/logos/siers.png";
import intratuinLogo from "@/assets/logos/intratuin.png";

const logos = [
  { name: "Emixa", url: emixaLogo },
  { name: "Fellowmind", url: fellowmindLogo },
  { name: "Conclusion", url: conclusionLogo },
  { name: "Berenschot", url: berenschotLogo },
  { name: "Siers", url: siersLogo },
  { name: "Intratuin", url: intratuinLogo },
];

export function ClientLogos({ showLabel = true }: { showLabel?: boolean }) {
  const { t } = useTranslation();
  return (
    <div className={`${showLabel ? "py-12" : "pt-2 pb-12"} overflow-hidden`}>
      <div className="container mx-auto">
        {showLabel && (
          <p className="text-center text-sm text-muted-foreground mb-8">
            {t("clients.trusted", "Vertrouwd door 350+ toonaangevende bedrijven")}
          </p>
        )}
        
        
        {/* Marquee Container */}
        <div 
          className="relative"
          style={{
            maskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
            WebkitMaskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)'
          }}
        >
          
          {/* Scrolling Track */}
          <div className="flex animate-marquee marquee-mobile">
            {/* First set of logos */}
            <div className="flex shrink-0 items-center gap-10 md:gap-16 px-5 md:px-8">
              {logos.map((logo) => (
              <img
                  key={logo.name}
                  src={logo.url}
                  alt={logo.name}
                  className="h-8 md:h-10 w-24 md:w-32 object-contain opacity-40 hover:opacity-70 transition-all duration-300"
                  style={{ filter: 'brightness(0) saturate(100%) invert(35%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(90%)' }}
              />
              ))}
            </div>
            
            {/* Duplicate set for seamless loop */}
            <div className="flex shrink-0 items-center gap-10 md:gap-16 px-5 md:px-8">
              {logos.map((logo) => (
              <img
                  key={`${logo.name}-duplicate`}
                  src={logo.url}
                  alt={logo.name}
                  className="h-8 md:h-10 w-24 md:w-32 object-contain opacity-40 hover:opacity-70 transition-all duration-300"
                  style={{ filter: 'brightness(0) saturate(100%) invert(35%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(90%)' }}
              />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
